import { useTheme } from '../hooks/useTheme.js';
import { labels } from '../labels.js';
import { Icon } from './Icon.js';

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();

  const handleClick = () => {
    document.documentElement.classList.add('theme-transition');
    toggleTheme();
    window.setTimeout(() => document.documentElement.classList.remove('theme-transition'), 250);
  };

  const dark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={labels.theme.toggle}
      title={dark ? labels.theme.light : labels.theme.dark}
      className="btn-icon btn-icon--quiet"
    >
      <Icon name={dark ? 'sun' : 'moon'} />
    </button>
  );
}
